import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';

const MATERIAL_SHORTAGE_PATH = '/mom/work-order/material-analysis/material-shortage';

function coerceWorkWarehouseIds(value) {
  if (Array.isArray(value)) {
    return value.map((id) => String(id).trim()).filter(Boolean);
  }
  if (value == null || value === '') {
    return [];
  }
  return String(value).split(',').map((id) => id.trim()).filter(Boolean);
}

/**
 * 有無選倉都走根層 `list[]`（`parseVer4ListResponse`）。
 * 若仍收到舊 `data.list`，抬成根層 list 當過渡；不要用 `data.warehouses`。
 *
 * @param {object} raw
 */
export function parseMaterialShortageListResponse(raw) {
  if (Array.isArray(raw?.list)) {
    return parseVer4ListResponse(raw);
  }

  const nestedList = raw?.data?.list;
  if (Array.isArray(nestedList)) {
    return parseVer4ListResponse({
      ...raw,
      list: nestedList,
    });
  }

  return parseVer4ListResponse(raw);
}

/**
 * 全域／選倉缺料（同一 route `mom.work_order.material_analysis.material_shortage`）。
 * 選倉只多一個 query：`work_warehouse_ids=id1,id2`（comma-separated，不要拆重複 key）。
 *
 * @param {{ workWarehouseIds?: string[]|string }} [options]
 */
export async function fetchWorkOrderMaterialShortage({ workWarehouseIds } = {}) {
  const ids = coerceWorkWarehouseIds(workWarehouseIds);
  const { data: raw } = await request.get(
    MATERIAL_SHORTAGE_PATH,
    ids.length > 0
      ? { params: { work_warehouse_ids: ids.join(',') } }
      : undefined,
  );
  return parseMaterialShortageListResponse(raw);
}
